<template>

<div class="support-tickets-home">
	<router-link v-if="getAdministratorFlag" to="/help-center/support-tickets-detail/new" class="button neutral inline" style="position: absolute; top: -2em; left: 0;" >Start a New Ticket</router-link>
	<div v-if="getAdministratorFlag" class="button neutral inline" style="position: absolute; top: -2em; right: 0;" @click="getList(true)"><i class="fa fa-redo" /> Refresh List</div>
	<div :class="['sub-header', 'filters', { filters_admin: getAdministratorFlag } ]">
		<router-link v-if="!getAdministratorFlag" class="button action" to="/help-center/support-tickets-detail/new">Start a New Ticket</router-link>
		<div>
			<label for="">Search</label>
			<input type="search" :placeholder="getAdministratorFlag ? 'Subject, content, dealer name...' : 'Subject or content contains...'" v-model="search_term" @keyup.enter.prevent="doSearch()">
		</div>
		<div v-if="getAdministratorFlag" class="filter">
			<label for="">Client</label>
			<select class="filter-client" :class="{ disabled: loadingStatusCodes }" v-model="clientId" @change="setFilter('client')">
				<option value="">Select...</option>
				<option v-for="(client, index) in clients" :value="client.client_id" :key="'client-filter-' + client.client_id">{{ client.company_name }} [{{ client.client_id }}]</option>
			</select>
		</div>
		<div v-if="getAdministratorFlag" class="filter">
			<label for="">Owner</label>
			<select class="filter-owner" :class="{ disabled: loadingStatusCodes }" v-model="owner" @change="setFilter('owner')">
				<option value="">Select...</option>
				<option v-for="(firstName, userId) in owners" :value="userId" :key="'user-filter-' + userId">{{ firstName }}</option>
			</select>
		</div>
		<div class="filter">
			<label for="">Status</label>
			<select class="filter-code" :class="{ disabled: loadingStatusCodes }" v-model="filter" :disabled="loadingStatusCodes" @change="setFilter('filter')">
				<option value="">Select...</option>
				<option v-for="(statusCode, index) in supportTicketStatusCodes" :value="statusCode.support_ticket_status_code"  :key="'status-filter-' + index">{{ statusCode.description }}</option>
				<option value="NOT_CLOSED">Not Closed</option>
				<option v-if="getAdministratorFlag" value="AUDIT">All (Audit Mode)</option>
			</select>
		</div>
		<div class="filter" v-if="getAdministratorFlag">
			<label for="">Tag</label>
			<select class="filter-code" :class="{ disabled: loadingTags }" v-model="tag" :disabled="loadingTags" @change="setFilter('tag')">
				<option value="">Select...</option>
				<option v-for="(tag, index) in supportTicketTags" :value="tag.support_ticket_tag_code" :key="'status-filter-' + index">{{ tag.description }}</option>
				<option value="NOT_TAGGED">Not Tagged</option>
				<option value="NOT_PRODUCT_EDIT">Not Product Edit</option>
			</select>
		</div>
		<div class="filter">
			<label for="">Sort</label>
			<select name="" id="" v-model="sort" @change="setFilter('sort')">
				<option value="">Select...</option>
				<option value="date">Date</option>
				<option value="status">Status</option>
				<option value="priority">Priority</option>
				<option v-if="getAdministratorFlag" value="id">Ticket ID</option>
			</select>
		</div>
		<div class="button neutral small" @click="clearFilters()" >Clear{{ getAdministratorFlag ? '' : ' Filters' }}</div>
		<div class="controls filter">
			<pagination v-if="!loading" :paging="paging" @updatePage="updatePage" style="margin: 0.75em 0 0 0;" :key="'pagination_' + paging.total_items"></pagination>
		</div>
	</div>
	<table v-if="supportTickets.length > 0" class="ticket-list" cellpadding="0" cellspacing="0">
		<router-link tag="tr" :to="{ path: '/help-center/support-tickets-detail/' + ticket.support_ticket_id, query: query(index) }" :class="[ ticket.support_ticket_priority_code.toLowerCase(), ticket.support_ticket_status_code.toLowerCase(), { orphan: !ticket.admin_name } ]" v-for="(ticket, index) in supportTickets" :key="'support-ticket-' + ticket.support_ticket_id">
			<td class="priority-cell">
				<div class="priority">
					<span class="priority-expanded">{{ ticket.support_ticket_priority_code }}</span>
				</div>
			</td>
			<td class="user">
				<template v-if="ticket.user_type_code.indexOf('ADMIN') > -1">
					<i class="fas fa-user-astronaut"></i>
					<span>{{ ticket.first_name }} {{ ticket.last_name }} at CDS</span>
				</template>
				<template v-else>
					<i class="far fa-user"></i>
					<span>{{ ticket.user_name }}<br>{{ ticket.user_type_code }}</span>
				</template>
			</td>
			<td class="topic">
				<h3>{{ ticket.topic }}</h3>
				<p>{{ ticket.excerpt }}</p>
			</td>
			<td class="meta">
				<div v-if="getAdministratorFlag" class="company-name"><b>{{ ticket.company_name }}</b></div>
				<div class="date-time">{{ $moment(ticket.support_ticket_detail_time).format('M/D/YY - h:mm a') }}</div>
				<div class="status">{{ ticket.support_ticket_id }} &rang; {{ ticket.support_ticket_status_code }}<span v-if="getAdministratorFlag && ticket.support_ticket_tag_code"> &rang; {{ ticket.support_ticket_tag_code }}</span></div>
				<div v-if="ticket.admin_name" class="status">Assigned To: <b>{{ ticket.admin_name }}</b></div>
			</td>
		</router-link>
		<tr>
			<td class="loading full-page" v-if="loading"><i class="fas fa-spinner fa-spin"></i></td>
		</tr>
	</table>
	<div v-else class="empty-list">
		There are no support tickets in this list.
	</div>
	<div :class="['sub-header', 'filters', { filters_admin: getAdministratorFlag } ]" style="margin: 1em 0 0 0;">
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div></div>
		<div v-if="getAdministratorFlag"></div>
		<div v-if="getAdministratorFlag"></div>
		<div class="controls">
			<pagination v-if="!loading" :paging="paging" @updatePage="updatePage" :key="'pagination_bottom_' + paging.total_items"></pagination>
		</div>
	</div>
</div>

</template>

<script>
import { mapGetters, mapActions } from "vuex"
export default {
	name: 'support-tickets-home',
	props: [ 'page' ],
	data() {
		return {
			loading: false,
			loadingStatusCodes: false,
			supportTickets: [],
			paging: {},
			owners: {},
			owner: '',
			clients: [],
			clientId: '',
			supportTicketStatusCodes: [],
			supportTicketTags: [],
			search_term: '',
			filter: '',
			tag: '',
			sort: '',
			token: '',
			windowInterval: false,
			lastSupportTicketDetailTime: '',
			message: ''
		}
	},
	created() {
		// enable token in query string (e.g. from FFL Office)
		const urlParams = new URLSearchParams(window.location.search);
		let urlToken = urlParams.get('fd_token')
		this.token = urlToken || this.$route.query.fd_token
		this.getStatusCodes()
		if (this.getAdministratorFlag) {
			this.getOwners()
		}
		this.sort = this.$route.query.sort || ''
		this.filter = this.$route.query.filter || ''
		this.search_term = this.$route.query.search_term || ''
		if (this.getAdministratorFlag) {
			this.apiCall({ destination: 'get_list_clients_full_list' }).then(obj => {
				this.clients = obj.clients
			}).catch(err => {
				console.log(err);
			})
		}
		this.getList()
	},
	mounted() {
		if (this.$route.query.owner) {
			this.owner = this.$route.query.owner
			this.getList()
		}
	},
	watch: {
		page(newVal) {
			this.getList()
		}
	},
	computed: {
		...mapGetters('dashboard_module', [
			'getSupportTickets'
		]),
	},
	methods: {
		...mapActions('dashboard_module', [
			'updateSupportTicketList'
		]),
		setFilter(which) {
			this.getList()
		},
		clearFilters() {
			this.search_term = ''
			this.filter = ''
			this.sort = ''
			this.tag = ''
			this.owner = ''
			this.clientId = ''
			if (this.page > 1) {
				this.$router.push('/help-center/support-tickets/1')
			} else {
				this.getList()
			}
		},
		getStatusCodes() {
			this.loadingStatusCodes = true
			this.apiCall({ destination: 'get_list_support_ticket_status_codes', data: { fd_token: this.token } }).then(obj => {
				this.supportTicketStatusCodes = obj.support_ticket_status_codes
				this.loadingStatusCodes = false
			}).catch(err => {
				this.loadingStatusCodes = false
				console.log(err);
			})
			if (this.getAdministratorFlag) {
				this.loadingTags = true
				this.apiCall({ destination: 'get_list_support_ticket_tags', data: { fd_token: this.token } }).then(obj => {
					this.supportTicketTags = obj.support_ticket_tags
					this.loadingTags = false
				}).catch(err => {
					this.loadingTags = false
					console.log(err);
				})
			}
		},
		getOwners() {
			this.apiCall({ destination: 'get_list_support_ticket_owners' }).then(obj => {
				if (obj.status == 'success') {
					this.owners = obj.owners
				}
			}).catch(err => {
				console.log(err);
			})
		},
		getList(sinceLastCheck = false) {
			if (this.loading) { return }
			if (!sinceLastCheck) { this.loading = true }
			var data = {
				page: this.page,
				search_term: this.search_term,
				filter: this.filter,
				sort: this.sort,
				fd_token: this.token
			}
			if (this.getAdministratorFlag) {
				data.client_id = this.clientId
				data.owner = this.owner
				data.tag = this.tag
				data.since_support_ticket_detail_time = this.lastSupportTicketDetailTime
			}
			this.apiCall({ destination: 'get_list_support_tickets', data: data }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.supportTickets = obj.support_tickets
					this.paging = obj.paging
					this.updateSupportTicketList(this.supportTickets)
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				this.loading = false
				console.log(err);
			})
		},
		query(index) {
			var query = {}
			Object.assign(query, this.$route.query)
			query.page = this.page
			return query
		},
		doSearch() {
			this.getList()
		},
		updatePage(page) {
			if (page > this.paging.total_pages) {
				page = this.paging.total_pages
			}
			this.$router.push({ path: '/help-center/support-tickets/' + page, query: this.$route.query })
		}
	}
}
</script>
